// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gw-0";
export var headerCellHover = "_gw-1";
export var readCellContainer = "_gw-2";
export var unreadIndicator = "_gw-3";